// extracted by mini-css-extract-plugin
var _1 = "Attachment_buttons__45PhS";
var _2 = "Attachment_date__Gc3hz";
var _3 = "Attachment_details__eLvBV";
var _4 = "Attachment_extension__mwOIv";
var _5 = "Attachment_imageIcon__JzXE4";
var _6 = "Attachment_imageSelected__DZ7Ak";
var _7 = "Attachment_name__-w5bF";
var _8 = "Attachment_optionButton__CCgQa";
var _9 = "Attachment_optionIcon__PrLM0";
var _a = "Attachment_optionText__JDiqS";
var _b = "Attachment_target__ceATv";
var _c = "Attachment_thumbnail__ZV8zK";
var _d = "Attachment_wrapper__N84wE";
var _e = "Attachment_wrapperSubmitting__2uk5J";
export { _1 as "buttons", _2 as "date", _3 as "details", _4 as "extension", _5 as "imageIcon", _6 as "imageSelected", _7 as "name", _8 as "optionButton", _9 as "optionIcon", _a as "optionText", _b as "target", _c as "thumbnail", _d as "wrapper", _e as "wrapperSubmitting" }
